var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st2{clip-path:url(#SVGID_00000129904444915928028680000006861701140446094522_);}\r\n\t.st3{clip-path:url(#SVGID_00000120557058254726704130000017347379099453461165_);}\r\n\t.st4{fill:#F2F2F2;}\r\n\t.st5{fill:#BDB6B8;}\r\n\t.st6{fill:#1A1A1A;}\r\n\t.st7{fill:#ADA8AA;}\r\n\t.st8{fill:#262424;}\r\n\t.st9{fill:#1E8273;}\r\n\t.st10{fill:#239281;}\r\n\t.st11{fill:#262626;}\r\n\t.st12{fill:#0F0F0F;}\r\n\t.st13{fill:#212226;}\r\n\t.st14{opacity:0.25;}\r\n\t.st15{clip-path:url(#SVGID_00000085970204324912226920000014066441671114563753_);}\r\n\t.st16{opacity:0.15;}\r\n\t.st17{clip-path:url(#SVGID_00000020359731113116227470000000204814959372615095_);}\r\n\t.st18{clip-path:url(#SVGID_00000011719885181025873700000016084977307983826606_);}\r\n\t.st19{clip-path:url(#SVGID_00000155132859247134902670000005892758723453978243_);}\r\n\t.st20{clip-path:url(#SVGID_00000106112347494601821580000002436083230227735207_);}\r\n\t.st21{clip-path:url(#SVGID_00000154389730361326807610000014162548562389185468_);}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7595",
    className: "st0",
    d: "M15,16H3c-0.6,0-1-0.4-1-1V3c0-0.6,0.4-1,1-1h5c0.6,0,1-0.4,1-1S8.6,0,8,0H2C0.9,0,0,0.9,0,2v14 c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2v-6c0-0.6-0.4-1-1-1s-1,0.4-1,1v5C16,15.6,15.6,16,15,16z M11,1c0,0.6,0.4,1,1,1h2.6l-9.1,9.1 c-0.4,0.4-0.3,1.1,0.1,1.4c0.4,0.3,0.9,0.3,1.3,0L16,3.4V6c0,0.6,0.4,1,1,1s1-0.4,1-1V1c0-0.6-0.4-1-1-1h-5C11.4,0,11,0.4,11,1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpen);
export default __webpack_public_path__ + "static/media/icon_open.b6b1d1702ddb095d0effe1e37c4fddfb.svg";
export { ForwardRef as ReactComponent };